/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { ALL_ROUTES, COMMON, DAKSH_SCREEN } from '../../global/Constants';
import DesktopFooter from '../common/DesktopFooter';
import Header from '../common/Header';
import Footer from '../common/Footer';
import './daksh.css';
import DakshHeader from './components/DakshHeader';
import Loader from '../common/loader/Loader';
import Utilities from '../../global/Utilities';
import ApiServices from '../../providers/ApiServices';
import { toast } from 'react-toastify';
import SyncLoader from '../common/loader/SyncLoader';

const STATUS = {
    PENDING: 0,
    COMPLETED: 1,
    REJECT: 2
}

class DakshApproval extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            dataLists: [
                // { retailer_name: "Retailer 1", village_name: "Bathinda", submitted_by: "Farmer 1", module_type: "1", status_type: 1, is_validated: true },
                // { retailer_name: "Retailer 2", village_name: "Bathinda", submitted_by: "Farmer 1", module_type: "2", status_type: 2, is_validated: false },
                // { retailer_name: "Retailer 3", village_name: "Bathinda", submitted_by: "Farmer 1", module_type: "2", status_type: 0, is_validated: true },
            ]

        }
    }

    componentDidMount() {
        if (Utilities.checkLogin()) {
            toast.configure();
            this.getDakshApprovalList();
        } else {
            this.props.history.replace(ALL_ROUTES.SIGN_IN_ROUTE);
        }
    }

    getDakshApprovalList = () => {
        if (Utilities.isNetworkConnected()) {

            this.setState({ isLoading: true });
            try {
                ApiServices.getDakshApprovalList("")
                    .then(response => {
                        Utilities.LogPrint("API_DATA: ---->", response);
                        this.setState({ isLoading: false });
                        if (response.success) {
                            const data = response.data;
                            if (data !== null) {
                                this.setState({
                                    dataLists: data
                                });
                            }
                        } else {
                            if (response.message === COMMON.TOKEN_EXPIRED) {
                                Utilities.tokenExpiredRedirectToLogin();
                            }
                        }
                    }).catch(error => {
                        this.setState({ isLoading: false });
                    });
            } catch (error) {
                this.setState({ isLoading: false, });
            }

        } else {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
        }
    }

    handelCardClick = (item) => {
        //this.props.history.push(ALL_ROUTES.DAKSH_APPROVE_REJECT);
        if (item.is_validated === false) {
            toast.info("This data is not validated with retailer. Please inform user to validate with retailer.");
            return;
        }
        let data = {
            dakshId: item.daksh_id,
            retailerId: item.retailer_id,
            moduleType: item.module_type,
            statusType: item.status_type
        }
        this.props.history.push({
            pathname: ALL_ROUTES.DAKSH_APPROVE_REJECT,
            state: { data: data }
        });
    }

    moduleStatus(status) {
        switch (status) {
            case STATUS.COMPLETED:
                return <span className="value status completed">Completed</span>;

            case STATUS.PENDING:
                return <span className="value status pending">Pending</span>;

            case STATUS.REJECT:
                return <span className="value status reject">Reject</span>;

            default:
                return;
        }
    }

    setModuleType = (moduleType) => {
        //Utilities.LogPrint("MOdule", moduleType);
        switch (parseInt(moduleType)) {
            case 1:
                return DAKSH_SCREEN.SALE;
            case 2:
                return DAKSH_SCREEN.PLAN;
            default:
                break;
        }
    }

    validateStatus = (status) => {
        if (status) {
            return (
                <div className="validate-sale">
                    VALIDATE <i className="customic ic-sale-green"></i>
                    {/*<i class="customic ic-sale-yellow"></i>
                                        <i class="customic ic-sale-red"></i>*/}
                </div>
            )
        } else {
            return (
                <div className="validate-sale">
                    NOT VALIDATE <i className="customic ic-sale-red"></i>
                </div>
            )
        }
    }

    handleSyncLoading = (loading, tableName) => {
        Utilities.LogPrint("handleSyncLoading", loading + tableName);
        this.setState({ isSyncLoading: loading, tableName })
    }

    render() {
        const { isLoading, isSyncLoading, tableName, dataLists } = this.state;
        return (
            <div>
                <Header handleSyncLoading={this.handleSyncLoading} />
                <Footer />

                <div className="container pt-35 daksh">
                    <DakshHeader />

                    {/* List */}
                    <div className="row sale-list">

                        {dataLists.length > 0 ?
                            dataLists.map((item, i) => (
                                <div className="col-12 col-lg-6 sale-list-item" key={i}>
                                    <div className="sale-list-item-wrapper" onClick={() => this.handelCardClick(item)}>
                                        {/* <div className="validate-sale">
                                            VALIDATE
                                            <i className="customic ic-sale-green"></i>
                                            <i class="customic ic-sale-yellow"></i>
                                            <i class="customic ic-sale-red"></i>
                                        </div> */}
                                        {this.validateStatus(item.is_validated)}
                                        <div>
                                            <label>Retailer Name</label>
                                            <span>:</span>
                                            <span className="value">{item.retailer_name}</span>
                                        </div>
                                        <div>
                                            <label>Village</label>
                                            <span>:</span>
                                            <span className="value">{item?.village_name}</span>
                                        </div>
                                        <div>
                                            <label>Submitted by</label>
                                            <span>:</span>
                                            <span className="value">{item?.submitted_by}</span>
                                        </div>
                                        <div>
                                            <label>Module type</label>
                                            <span>:</span>
                                            <span className="value">{this.setModuleType(item.module_type)}</span>
                                        </div>
                                        <div>
                                            <label>Status</label>
                                            <span>:</span>
                                            {this.moduleStatus(item.status_type)}
                                            {/* <span className="value status completed">Completed</span> */}
                                        </div>
                                    </div>
                                </div>
                            )) : null
                        }

                        {/* <div className="col-12 col-lg-6 sale-list-item">
                            <div className="sale-list-item-wrapper">
                                <div className="validate-sale">
                                    VALIDATE <i className="customic ic-sale-green"></i>
                                </div>
                                <div>
                                    <label>Retailer Name</label><span>:</span><span className="value">Retailer 1</span>
                                </div>
                                <div>
                                    <label>Village</label><span>:</span><span className="value">Bathinda</span>
                                </div>
                                <div>
                                    <label>Submitted by</label><span>:</span><span className="value">Farmer 1</span>
                                </div>
                                <div>
                                    <label>Module type</label><span>:</span><span className="value">Pre Season</span>
                                </div>
                                <div>
                                    <label>Status</label><span>:</span><span className="value status pending">Pending</span>
                                </div>
                            </div>
                        </div> */}

                    </div>

                </div>
                <DesktopFooter />
                {isLoading ? <Loader /> : null}
                {isSyncLoading ? <SyncLoader tableName={tableName} /> : null}
            </div>

        )
    }
}

export default withRouter(DakshApproval);